import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class RelatorioDesempenhoService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'relatorio-desempenho');
  }

  gerarRelatorio(dataInicial: string, dataFinal: string, estacoes?: number[], clientes?: number[], geral?: boolean): Observable<any> {
    const params: any = {
      data_inicial: dataInicial,
      data_final: dataFinal
    };

    if (geral === true) {
      params.geral = true;
    } else {
      if (estacoes && estacoes.length > 0) {
        params.estacoes = estacoes;
      }

      if (clientes && clientes.length > 0) {
        params.clientes = clientes;
      }
    }

    return this.http.post(`${this.url_base}/${this.prefixo}`, params);
  }

  gerarRelatorioDiario(dataInicial: string, dataFinal: string, estacoes?: number[], clientes?: number[], geral?: boolean): Observable<any> {
    const params: any = {
      data_inicial: dataInicial,
      data_final: dataFinal
    };

    if (geral === true) {
      params.geral = true;
    } else {
      if (estacoes && estacoes.length > 0) {
        params.estacoes = estacoes;
      }

      if (clientes && clientes.length > 0) {
        params.clientes = clientes;
      }
    }

    return this.http.post(`${this.url_base}/${this.prefixo}/diario`, params);
  }
}

